import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  listSerialTemp (URL, header, success, error) {
    Vue.axios.get(URL + 'imports/temp', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  listSerial (URL, header, success, error) {
    Vue.axios.get(URL + 'imports', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addSerialTemp (URL, obj, header, success, error) {
    Vue.axios.post(URL + 'imports/temp', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addSerial (URL, obj, header, success, error) {
    Vue.axios.post(URL + 'imports', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteSerialTemp (URL, Id, header, success, error) {
    Vue.axios.delete(URL + 'imports/' + Id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteSerialTempAll (URL, Id, header, success, error) {
    Vue.axios.delete(URL + 'imports/all/' + Id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/imports.js